import React from 'react';
import { Outlet } from 'react-router-dom';

const ReportsLayout = () => {
  return (
    <div className='border p-2 rounded' style={{ background: '#fff' }}>
      <Outlet />
    </div>
  );
};

export default ReportsLayout;

